<template>
  <ul class="navs">
    <li
      :class="{ active: $route.fullPath === link.url }"
      class="link"
      v-for="link in list"
      :key="link.url"
    >
      <nuxt-link :to="link.url">
        <i
          v-html="link.icon"
          class="iconfont"
        ></i>
        {{ link.text }}
      </nuxt-link>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { text: "我的发表", url: "/my/publish", icon: "&#xe6ed;" },
        { text: "我的收藏", url: "/my/favorite", icon: "&#xe849;" },
        { text: "我的粉丝", url: "/my/follower", icon: "&#xe60c;" },
        { text: "我的关注", url: "/my/following", icon: "&#xe61a;" },
        { text: "我的自选", url: "/my/stock", icon: "&#xe619;" },
        // { text: '我的评论', url: '/my/comment', icon: '&#xe664;' },
        { text: "我的已购", url: "/my/purchase", icon: "&#xe65e;" },
        { text: "资料设置", url: "/my/setting", icon: "&#xe682;" }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.navs {
  display: flex;
  flex-direction: column;

  width: 230px;

  background: #fff;

  .link {
    a {
      display: inline-block;

      width: 100%;
      padding: 21px 30px;

      font-size: 16px;

      color: #000;
    }
  }

  .active {
    border-left: 2px solid #3278d2;

    a {
      background: #f3f8ff;
      color: #3278d2;
    }
  }
}
</style>
